import dynamic from 'next/dynamic';
import { FC } from 'react';
import { GlacierWaveProps } from '../interface';
import css from './index.module.scss';
import A from './components/A';

const PageConPc = dynamic(() => import('./indexDynamic'), {
    ssr: true,
});

const GlacierWaveTreaserPC: FC<GlacierWaveProps> = (props) => {
    return (
        <div className={css.glacierWaveTreaserPC}>
            <A {...props} />
            <PageConPc {...props} />
            <style jsx global>
                {`
                    .wbg {
                        display: none;
                    }
                `}
            </style>
        </div>
    );
};

export default GlacierWaveTreaserPC;
